<template>
    <div class="checkout-block">
        <div class="checkout-block__header">
            <slot name="header" />
        </div>
        <div
            class="checkout-block__content"
        >
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'CheckoutBlock',
}
</script>

<style lang="scss" scoped>
.checkout-block{
    background-color: #fff;
    padding: 24px 16px;
    @include point-md{
        padding: 32px 24px;
    }
    &__header{
        :deep(.def-title) {
            margin-bottom: 24px;
            line-height: 100%;
        }
    }
    &__content{
    }
    :deep(.width-limiter){
        @include point-md{
            max-width: 356px;
        }
        @include point-lg{
            max-width: 400px;
        }
    }
}
</style>